import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const OdlozenaServisniCinnost = {
	name: NAME,
	apiProvider,
	router,
};
